import { Cart, DeliveryMode } from '@spartacus/cart/base/root';
import { Address } from '@spartacus/core';
import { Order, ReplenishmentOrder } from '@spartacus/order/root';
import {
  CLEAR_CHECKOUT_DATA,
  ReplenishmentOrderActions,
  SCHEDULE_REPLENISHMENT_ORDER_SUCCESS
} from '../actions/checkout-group.actions';
import {
  ADD_DELIVERY_ADDRESS_SUCCESS,
  CHECKOUT_CLEAR_MISCS_DATA, CLEAR_CHECKOUT_DELIVERY_ADDRESS,
  CLEAR_CHECKOUT_DELIVERY_MODE,
  CLEAR_CHECKOUT_STEP,
  CLEAR_SUPPORTED_DELIVERY_MODES,
  CREATE_PAYMENT_DETAILS_FAIL,
  CREATE_PAYMENT_DETAILS_SUCCESS,
  CheckoutAction,
  CheckoutClearMiscsData,
  LOAD_CHECKOUT_DETAILS_SUCCESS,
  LOAD_SUPPORTED_DELIVERY_MODES_SUCCESS,
  PLACE_ORDER_SUCCESS,
  SET_COST_CENTER_SUCCESS,
  SET_DELIVERY_ADDRESS_SUCCESS,
  SET_DELIVERY_MODE_SUCCESS,
  SET_PAYMENT_DETAILS_SUCCESS
} from '../actions/checkout.action';
import { SET_PAYMENT_TYPE_SUCCESS, SetPaymentTypeSuccess } from '../actions/custom-payment-types.action';
import { CheckoutStepsState } from '../custom-checkout-state';

export const initialState: CheckoutStepsState = {
  poNumber: { po: undefined, costCenter: undefined },
  address: {},
  deliveryMode: {
    supported: {},
    selected: '',
  },
  paymentDetails: {},
  orderDetails: {},
};

export function reducer(
  state = initialState,
  action:
    | CheckoutAction
    | CheckoutClearMiscsData
    | SetPaymentTypeSuccess
    | ReplenishmentOrderActions
): CheckoutStepsState {
  switch (action.type) {
    case SET_PAYMENT_TYPE_SUCCESS: {
      const cart: Cart = action.payload;
      return {
        ...state,
        poNumber: {
          ...state.poNumber,
          po: cart.purchaseOrderNumber,
        },
      };
    }

    case SET_COST_CENTER_SUCCESS: {
      return {
        ...state,
        poNumber: {
          ...state.poNumber,
          costCenter: action.payload,
        },
      };
    }

    case ADD_DELIVERY_ADDRESS_SUCCESS:
    case SET_DELIVERY_ADDRESS_SUCCESS: {
      const address: Address = action.payload;

      return {
        ...state,
        address,
      };
    }

    case LOAD_SUPPORTED_DELIVERY_MODES_SUCCESS: {
      const supportedModes = action.payload;
      if (!supportedModes) {
        return state;
      }

      const supported = supportedModes.reduce(
        (modes: { [code: string]: DeliveryMode }, mode: DeliveryMode) => {
          return {
            ...modes,
            [mode.code]: mode,
          };
        },
        {
          ...state.deliveryMode.supported,
        }
      );

      return {
        ...state,
        deliveryMode: {
          ...state.deliveryMode,
          supported,
        },
      };
    }

    case SET_DELIVERY_MODE_SUCCESS: {
      const selected = action.payload;

      return {
        ...state,
        deliveryMode: {
          ...state.deliveryMode,
          selected,
        },
      };
    }

    case CREATE_PAYMENT_DETAILS_SUCCESS:
    case SET_PAYMENT_DETAILS_SUCCESS: {
      return {
        ...state,
        paymentDetails: action.payload,
      };
    }

    case CREATE_PAYMENT_DETAILS_FAIL: {
      const paymentDetails = action.payload;
      if (paymentDetails['hasError']) {
        return {
          ...state,
          paymentDetails,
        };
      }

      return state;
    }

    case PLACE_ORDER_SUCCESS:
    case SCHEDULE_REPLENISHMENT_ORDER_SUCCESS: {
      const orderDetails: Order | ReplenishmentOrder = action.payload;

      return {
        ...state,
        orderDetails,
      };
    }

    case CLEAR_CHECKOUT_DATA: {
      return initialState;
    }

    case CLEAR_CHECKOUT_STEP: {
      const stepNumber = action.payload;
      switch (stepNumber) {
        case 1: {
          return {
            ...state,
            address: {},
          };
        }

        case 2: {
          return {
            ...state,
            deliveryMode: {
              ...state.deliveryMode,
              supported: {},
              selected: '',
            },
          };
        }

        case 3: {
          return {
            ...state,
            paymentDetails: {},
          };
        }
      }

      return state;
    }

    case CLEAR_SUPPORTED_DELIVERY_MODES:
    case CHECKOUT_CLEAR_MISCS_DATA: {
      return {
        ...state,
        deliveryMode: {
          ...state.deliveryMode,
          supported: {},
        },
      };
    }
    case LOAD_CHECKOUT_DETAILS_SUCCESS: {
      return {
        ...state,
        address: action.payload.deliveryAddress,
        deliveryMode: {
          ...state.deliveryMode,
          selected:
            action.payload.deliveryMode && action.payload.deliveryMode.code,
        },
        paymentDetails: action.payload.paymentInfo,
      };
    }

    case CLEAR_CHECKOUT_DELIVERY_ADDRESS: {
      return {
        ...state,
        address: {},
      };
    }

    case CLEAR_CHECKOUT_DELIVERY_MODE: {
      return {
        ...state,
        deliveryMode: {
          ...state.deliveryMode,
          selected: '',
        },
      };
    }
  }

  return state;
}
